import React, { useState, useEffect } from "react";
import { 
  LayoutDashboard, Users, ArrowDownToLine, 
  WalletCards, ArrowRightLeft, FileWarning, CalendarDays, Scale, ShieldCheck, 
  Settings, LogOut, Menu, X, Home 
} from "lucide-react";

import Dashboard from "./Dashboard";
import Reports from "./Reports";
import Transactions from "./Transactions"; 
import Owners from "./Owners";
import Transfers from "./Transfers";
import Charges from "./Charges";
import Periods from "./Periods";
import SettingsPage from "./Settings";
import Balance from "./Balance";
import Balances from "./Balances";
import Userss from "./Userss";

const nav = [
  { id: "dashboard", label: "Ana Menü", icon: LayoutDashboard },
  { id: "transactions", label: "Gelir & Gider", icon: ArrowDownToLine },
  { id: "owners", label: "Malik Hesapları", icon: Users },
  { id: "reports", label: "Raporlar", icon: WalletCards },
  { id: "transfers", label: "Para Transferleri", icon: ArrowRightLeft },
  { id: "charges", label: "Borçlandırma", icon: FileWarning },
  { id: "balances", label: "Bilanço", icon: Scale },
  // Sadece Yöneticilerin Görebileceği Menüler
  { id: "periods", label: "Dönemler", icon: CalendarDays, adminOnly: true },
  { id: "users", label: "Yetkilendirme", icon: ShieldCheck, adminOnly: true },
  { id: "settings", label: "Ayarlar", icon: Settings, adminOnly: true }
];

export default function AdminApp({ user, onLogout }) {
  const [activeTab, setActiveTab] = useState("dashboard");
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleNavClick = (id) => {
    setActiveTab(id);
    if (isMobile) setIsMobileMenuOpen(false);
  };

  const renderContent = () => {
    switch (activeTab) {
      case "dashboard":
        return <Dashboard user={user} onNavigate={handleNavClick} />;
      case "reports":
        return <Reports initialReport="menu" />;
      case "reports_gider":
        return <Reports initialReport="gider" />;
      case "reports_gelir":
        return <Reports initialReport="gelir" />;  
      case "transactions":
        return <Transactions />;
      case "owners":
        return <Owners />;
      case "transfers":
        return <Transfers />; 
      case "charges":
        return <Charges />;
      case "periods":
        return <Periods />;
      case "balance":
        return <Balance />;
      case "balances":
        return <Balances />;
      case "settings":
        return <SettingsPage />;
      case "users":
        return <Userss />;
      default:
        return (
          <div style={{ padding: "20px", textAlign: "center", color: "#64748b", background: "white", borderRadius: "16px" }}>
            <h2>Yapım Aşamasında</h2>
            <p>Bu sekme ({activeTab}) henüz modüler yapıya bağlanmadı...</p>
          </div>
        );
    }
  };

  const sidebarStyle = isMobile ? {
    position: "fixed", top: 0, left: isMobileMenuOpen ? 0 : "-100%", width: "280px", height: "100%", backgroundColor: "#1e293b", color: "white", display: "flex", flexDirection: "column", zIndex: 9999, transition: "left 0.3s ease-in-out", boxShadow: isMobileMenuOpen ? "4px 0 25px rgba(0,0,0,0.5)" : "none"
  } : {
    width: "250px", backgroundColor: "#1e293b", color: "white", display: "flex", flexDirection: "column", minHeight: "100vh"
  };

  // KULLANICI YÖNETİCİ Mİ KONTROLÜ BURADA OLMALI
  const isAdmin = user?.role === "Yönetici" || user?.role === "Süper Yönetici";

  return (
    <div style={{ display: "flex", minHeight: "100vh", backgroundColor: "#f8fafc", flexDirection: isMobile ? "column" : "row" }}>
      
      {isMobile && (
        <header style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "16px 20px", backgroundColor: "#1e293b", color: "white", boxShadow: "0 2px 10px rgba(0,0,0,0.1)" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <button onClick={() => handleNavClick("dashboard")} style={{ background: "none", border: "none", color: "#3b82f6", cursor: "pointer", display: "flex", alignItems: "center" }}>
              <Home size={26} />
            </button>
            <span style={{ fontSize: "16px", fontWeight: "bold", letterSpacing: "0.5px" }}>BAŞKENT SİTESİ</span>
          </div>
          <button onClick={() => setIsMobileMenuOpen(true)} style={{ background: "none", border: "none", color: "white", cursor: "pointer", display: "flex", alignItems: "center" }}>
            <Menu size={28} />
          </button>
        </header>
      )}

      {isMobile && isMobileMenuOpen && (
        <div 
          onClick={() => setIsMobileMenuOpen(false)}
          style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", backgroundColor: "rgba(0,0,0,0.5)", zIndex: 9998, backdropFilter: "blur(2px)" }}
        />
      )}

      <aside style={sidebarStyle}>
        <div style={{ padding: "20px", fontSize: "18px", fontWeight: "bold", borderBottom: "1px solid #334155", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <span>Yönetim Paneli</span>
          {isMobile && (
            <button onClick={() => setIsMobileMenuOpen(false)} style={{ background: "none", border: "none", color: "#94a3b8", cursor: "pointer", display: "flex", alignItems: "center" }}>
              <X size={24} />
            </button>
          )}
        </div>
  
        <nav style={{ flex: 1, padding: "10px 0", overflowY: "auto" }}>
          {/* FİLTRELEME BURAYA EKLENDİ */}
          {nav.filter(item => !item.adminOnly || isAdmin).map((item) => {
            const Icon = item.icon;
            // Eğer doğrudan gider raporuna gidilmişse, yan menüdeki 'Raporlar' mavi kalsın
            const isActive = activeTab === item.id || (activeTab === "reports_gider" && item.id === "reports");
            return (
              <button 
                key={item.id}
                onClick={() => handleNavClick(item.id)}
                style={{
                  width: "100%", display: "flex", alignItems: "center", gap: "12px",
                  padding: "14px 20px", backgroundColor: isActive ? "#3b82f6" : "transparent",
                  color: isActive ? "white" : "#cbd5e1", border: "none", cursor: "pointer",
                  textAlign: "left", fontSize: "15px", fontWeight: isActive ? "600" : "400",
                  transition: "all 0.2s"
                }}
              >
                <Icon size={20} /> {item.label}
              </button>
            );
          })}
        </nav>

        <div style={{ padding: "20px", borderTop: "1px solid #334155" }}>
          <div style={{ fontSize: "13px", color: "#94a3b8", marginBottom: "4px", paddingLeft: "4px" }}>
            {user?.name || "Kullanıcı"}
          </div>
          
          <button onClick={onLogout} style={{ display: "flex", alignItems: "center", gap: "8px", background: "#ef444420", border: "none", color: "#ef4444", cursor: "pointer", fontSize: "14px", width: "100%", padding: "10px 14px", borderRadius: "8px", fontWeight: "bold", transition: "all 0.2s" }}>
            <LogOut size={18} /> Güvenli Çıkış
          </button>
        </div>
      </aside>

      <main style={{ flex: 1, padding: isMobile ? "15px" : "30px", overflowY: "auto", overflowX: "hidden" }}>
        {renderContent()}
      </main>
    </div>
  );
}